var _defs, _g, _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "accept-icon-svg",
    version: 1.1,
    viewBox: "0 0 154.5 154.5"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Base_Circle",
    className: "st42"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st41",
    cx: 627.8,
    cy: -1308.6,
    r: 77.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st41",
    cx: 1306.2,
    cy: -1308.6,
    r: 77.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st41",
    cx: 1524.8,
    cy: -1308.6,
    r: 77.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st41",
    cx: 1080.8,
    cy: -1308.6,
    r: 77.2,
    transform: "translate(1241.9 381) rotate(-45)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st41",
    cx: 175.8,
    cy: -1307.6,
    r: 77.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st41",
    cx: 855.2,
    cy: -1313.6,
    r: 77.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st41",
    cx: 403.8,
    cy: -1308.6,
    r: 77.2
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st43",
    cx: 77.2,
    cy: 77.2,
    r: 77.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M36.2,79.7l22.2,26.6c1.1,1.3,3.2,1.4,4.4.1l55.4-59.4"
  })));
};
export default __webpack_public_path__ + "static/media/submit_new_nosel.55991178.svg";
export { SvgComponent as ReactComponent };